<template>
	<nut-popup
		:visible="colorQuickSelectVisible"
		position="bottom"
		round
		closeable
		@close="() => handleClose('quick')"
	>
		<div class="pop-title">颜色快捷选择</div>
		<div class="colors">
			<nut-radiogroup
				v-if="Array.isArray(colorOptions) && colorOptions.length"
				:model-value="color"
				direction="horizontal"
			>
				<nut-radio
					:label="color.value"
					:key="color.value"
					v-for="color in colorOptions"
					@click="() => handleRadioChange(color.value)"
				>
					<span
						class="color-item"
						:style="{
							background: color.value,
							border:
								color.value === '#FFFFFF'
									? '1px solid #e6e6e6'
									: 'none',
						}"
					></span>
				</nut-radio>
			</nut-radiogroup>
			<empty v-else text="暂无快捷颜色选择！" />
		</div>
	</nut-popup>
	<nut-popup
		:visible="colorCustomSelectVisible"
		position="bottom"
		@close="() => handleClose('custom')"
	>
		<color-picker
			style="width: 100%"
			:model-value="color"
			@update:modelValue="handlePickCustomColor"
		/>
	</nut-popup>
</template>

<script>
import { Chrome as ColorPicker } from '@ckpack/vue-color';
import { Empty } from '@/components';
export default {
	name: 'SelectColor',
	components: {
		ColorPicker,
		Empty,
	},
	props: {
		colorQuickSelectVisible: Boolean,
		colorCustomSelectVisible: Boolean,
		color: String,
		colorOptions: Array,
	},
	emits: [
		'update:colorQuickSelectVisible',
		'update:colorCustomSelectVisible',
		'update:color',
	],
	setup(props, { emit }) {
		const handleClose = (type) => {
			emit(
				type === 'quick'
					? 'update:colorQuickSelectVisible'
					: 'update:colorCustomSelectVisible',
				false
			);
		};

		const handleRadioChange = (val) => {
			emit('update:color', val);
		};
		const handlePickCustomColor = (color) => {
			emit('update:color', color.hex);
		};
		return {
			handleClose,
			handleRadioChange,
			handlePickCustomColor,
		};
	},
};
</script>

<style lang="scss" scoped>
.pop-title {
	height: 60px;
	line-height: 60px;
	border-bottom: 1px solid #e6e6e6;
	font-size: 16px;
	text-align: center;
}

.colors {
	padding: 20px;
	display: flex;
	flex-wrap: wrap;

	:deep(.nut-radio) {
		margin-bottom: 15px;
	}
	.color-item {
		display: inline-block;
		box-sizing: border-box;
		height: 24px;
		width: 44px;
	}
}
</style>
